import React, { useState } from "react";
import "./workshops.css";

import ezel from "../../img/workshop-ezel.jpg";
import kat from "../../img/workshop-kat.jpg";
import nijlpaard from "../../img/workshop-nijlpaard.jpg";

const images = [ezel, kat, nijlpaard];
function Workshop() {
  const [mainIndex, setMainIndex] = useState(0);

  return (
    <div className="workshopspage-container">
      <div className="workshopspage-layout">
        <div className="workshopspage-left">
          <div className="workshop-details">
            <h1>🎨 Workshop Dierfiguren Boetseren</h1>

            <p>
              Als je bij mij een standaard workshop komt volgen duurt dit
              ongeveer 4 uur. Dit kan in de ochtend, middag of avond zijn. Je
              hebt dan de keuze uit 3 voorbeelden die ik voor je klaarzet. Als
              je werkstuk daarna helemaal droog is, bak ik het voor je; het is
              dan biscuit-gebakken. Je kan het dan thuis zelf verven met
              plakkaatverf en vernis. De kosten van deze workshop zijn rond de
              35 euro.
            </p>

            <p>
              De ervaring leert mij dat een halve dag kleien vaak te weinig is.
              Je kan dan ook een hele dag komen en ik zorg dan niet alleen voor
              wat lekkers bij de koffie/ thee, maar ook voor een lekkere lunch.
              De kosten van zo'n hele dag zijn 50 euro.
            </p>

            <h2>Glazuren</h2>
            <p>
              Wil je je werkstuk na de biscuit stook ook glazuren, dan komen er
              extra kosten bij voor glazuur en de glazuurstook. De kosten zijn
              afhankelijk van de grote van je werkstuk en de keuze van de
              glazuur. De kosten zitten meestal rond de 40 euro.
            </p>

            <p>
              Als je werkstukken biscuit en/of glazuurstook gebakken zijn,
              kunnen ze in de winter NIET buiten blijven staan. Je kan een
              werkstuk ook hoog stoken en dan kan het meestal wel in de winter
              buiten blijven, maar voor deze bewerking is er speciale glazuur.
            </p>

            <h2>Eigen wensen</h2>
            <p>
              Uiteraard zijn alle andere wensen bespreekbaar en mag je zelf
              bepalen wat je maken wil, maar dan moeten we het wel eerst over de
              prijs hebben (om misverstanden te voorkomen!).
            </p>

            <p>
              In de ruimte waar ik werk kan ik maximaal 6 cursisten plaatsen.
              Hou er rekening mee dat er steentjes zitten in de klei en dat dit
              sieraden kan beschadigen. Glazuren kan vlekken maken op kleding,
              dus kleed je daarop.
            </p>
          </div>
        </div>

        <div className="workshopspage-right">
          <div className="main-image-container">
            <img
              src={images[mainIndex]}
              alt={`Workshop afbeelding ${mainIndex + 1}`}
              className="main-image"
            />
          </div>

          <div className="thumbnail-row">
            {images.map((img, i) => (
              <img
                key={i}
                src={img}
                alt={`Thumbnail ${i + 1}`}
                className={`thumbnail-thumb ${i === mainIndex ? "active" : ""}`}
                onClick={() => setMainIndex(i)}
              />
            ))}
          </div>

          <a href="/contact" className="workshopspage-button">
            Doe ook een workshop !!
          </a>

          <aside className="workshopspage-quotes">
            <h3>🗣️ Wat anderen zeggen</h3>

            <div className="review-box">
              <span className="stars">★★★★★</span>
              <a>gemiddelde beoordeling</a>
            </div>

            <blockquote>
              “Ik dacht dat ik niet creatief was, maar ik heb echt iets moois
              gemaakt al hier zeker nog eens naar toe gaan!”
              <span>- Marina (52)</span>
            </blockquote>
            <blockquote>
              “De sfeer was super gezellig en het ging stap voor stap. Echt
              ontspannen.”
              <span>- joep (54)</span>
            </blockquote>
            <blockquote>
              “Zo leuk om met klei bezig te zijn. Dit doe ik zeker nog een
              keer!”
              <span>- Els (69)</span>
            </blockquote>
          </aside>
        </div>
      </div>
    </div>
  );
}

export default Workshop;
